export function updateCheckoutForm(response) {
  Site.getRequest("/checkout", e => {
    let html = document.createElement("html");
    html.innerHTML = e.target.responseText;
    let resSummary = document.querySelector(".reservation-summary");
    let promoCode = document.querySelector(".promo-code");
    let addOns = document.querySelector(".add-ons");
    const addOnsTabsOpened = addOns.querySelectorAll(".add-ons__tab.open");
    const addOnsOpenedTabIDs = !!addOnsTabsOpened.length &&
      Array.prototype.map.call(addOnsTabsOpened, item => item.getAttribute("id")).filter(Boolean);
    let travelInsurance = document.querySelector(".travel-insurance");
    let newResSummary = html.querySelector(".reservation-summary");
    let newPromoCode = html.querySelector(".promo-code");
    let newAddOns = html.querySelector(".add-ons");
    // we replace current addons with the ones which come from request
    // hence having 2 open tabs. to Prevent it we first clear open tabs.
    newAddOns.querySelector('.open').classList.remove('open');
    if (addOnsOpenedTabIDs.length && newAddOns) {
      addOnsOpenedTabIDs.forEach(item => {
        newAddOns.querySelector(`#${item}`).classList.add('open');
      });
    }
    let newTravelInsurance = html.querySelector(".travel-insurance");
    resSummary.innerHTML = newResSummary.innerHTML;
    promoCode.innerHTML = newPromoCode.innerHTML;
    addOns.innerHTML = newAddOns.innerHTML;
    travelInsurance.innerHTML = newTravelInsurance.innerHTML;

    // replace experience overlays
    let expOverlays = document.querySelectorAll(".experience-overlay");
    let newExpOverlays = html.querySelectorAll(".experience-overlay");

    expOverlays.forEach((el, idx) => {
      el.innerHTML = newExpOverlays[idx].innerHTML;
    });

    // add error state to promo code field
    if (response.discount == 0 && response.promoCodeId !== null && response.promoCodeId.length > 0) {
      promoCode.classList.add("error");
      const errorMsg = document.createElement("span");
      errorMsg.classList.add("error-msg");
      errorMsg.innerText = "The code you entered is invalid";
      document.querySelector(".promo-field-group").appendChild(errorMsg);
    } else {
      promoCode.classList.remove("error");
    }

    let event = new CustomEvent("reservation-update");
    window.dispatchEvent(event);
  });
}

export function submitAddOn(addOn) {
  let params = Site.getQuoteParams();
  let addOns = params.addOns || [];
  let found = addOns.findIndex(a => a.id == addOn.id);
  if (found != -1) {
    addOns[found] = addOn;
  } else {
    addOns.push(addOn);
  }

  params["addOns"] = addOns;
  Site.postJson("/quote", params, this.updateAddOns.bind(this));
}

export function removeAddOn(e) {
  e.preventDefault();
  let data = { add_on: e.target.dataset.id };
  Site.postJson("/quote/remove-add-on", data, this.updateAddOns.bind(this));
}
